import { RootState } from 'store/reducers/types';
import { combineReducers, Reducer, AnyAction } from "redux";
import session from "store/reducers/data/session";
import dashboard from "store/reducers/dashboard";
import recruiterIds from "store/reducers/data/recruiterId";
import filters from "store/reducers/data/filters";
import jobList from "store/reducers/jobList";
import commentReport from "store/reducers/commentReport";
import assignmentReport from "store/reducers/assignmentReport";
import myTasks from 'store/reducers/myTasks';
import associates from 'store/reducers/associates';
import workedInLast30Days from 'store/reducers/workedInLast30Days';
import workerReport from 'store/reducers/workerReport';
import { RESET_SESSION_STATE } from 'store/reducers/types/session';

const appReducer: Reducer<RootState> = combineReducers({
  dashboard,
  recruiterIds,
  filters,
  session,
  jobList,
  myTasks,
  commentReport,
  assignmentReport,
  associates,
  workedInLast30Days,
  workerReport
});

const rootReducer: Reducer<RootState> = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === RESET_SESSION_STATE) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
